module.exports = __webpack_public_path__ + "static/media/kite_surfing_768.45d149b3.jpg";